module.exports = __webpack_public_path__ + "img/sv94.2fe79c63.svg";